import Combobox from './combobox';
import { ready, fetchApiUrl } from './utilities';

let container;
ready(init);

async function init() {
  // Check for both containers - index page and overview page
  container = document.querySelector('.js-politician-table');
  const politicianFilterElem = document.querySelector('#politician-filter');

  if (!politicianFilterElem) {
    return;
  }

  const selectedPolitician = new URLSearchParams(window.location.search).get('politician');
  const politiciansReq = await fetchApiUrl('/api/v1/politicians');
  const politicians = await politiciansReq.json();

  new Combobox({
    valueKey: 'slug',
    selected: selectedPolitician,
    root: politicianFilterElem,
    search: async (text) => {
      return politicians.filter((politician) => {
        return politician.name.toLowerCase().includes(text.toLowerCase());
      });
    },
    render: (politician, value) => {
      const div = document.createElement('div');
      div.textContent = politician.name + (politician.party ? ` (${politician.party})` : '');
      return div;
    },
    update: (value) => {
      if (value) {
        window.location.href = `/congress-stock-trades/${value}`;
      }
    }
  });

  // Stock filter
  const stockFilterElem = document.querySelector('#stock-filter');
  const selectedStock = new URLSearchParams(window.location.search).get('stock');

  new Combobox({
    valueKey: 'symbol',
    selected: selectedStock,
    root: stockFilterElem,
    search: async (text) => {
      const stocksReq = await fetchApiUrl('/api/v1/stocks?query=' + text);
      const stocks = await stocksReq.json();
      if (text === '' || 'municipal bonds'.includes(text.toLowerCase())) {
        stocks.unshift({ name: 'Municipal Bonds', symbol: 'municipal-bonds' });
      }
      if (text === '' || 'crypto currencies'.includes(text.toLowerCase()) || 'bitcoin'.includes(text.toLowerCase()) || 'ethereum'.includes(text.toLowerCase())) {
        stocks.unshift({ name: 'Crypto Currencies', symbol: 'crypto' });
      }
      if (text === '' || 'treasury'.includes(text.toLowerCase()) || 'treasuries'.includes(text.toLowerCase())) {
        stocks.unshift({ name: 'US Treasuries', symbol: 'treasury' });
      }
      return stocks;
    },
    render: (stock, value) => {
      const div = document.createElement('div');
      const symbol = ['treasury', 'crypto', 'municipal-bonds'].includes(stock.symbol) ? '' : `(${stock.symbol})`;
      div.textContent = `${stock.name} ${symbol}`;
      return div;
    },
    update: (value) => {
      updatePage('stock', value);
    }
  });

  // Party filter
  let selectedParty = new URLSearchParams(window.location.search).get('party') || 'all';
  const partyButtons = document.getElementsByName('party-filter');
  partyButtons.forEach((button) => {
    if (button.value === selectedParty) {
      button.checked = true;
    }
    button.addEventListener('click', () => {
      selectedParty = button.value;
      updatePage('party', selectedParty === 'all' ? null : selectedParty);
    });
  });

  const summaryFilterButtons = document.querySelectorAll('[data-party-summary-filter]');
  summaryFilterButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const party = button.getAttribute('data-party-summary-filter');
      if (!party) return;
      const matchingRadio = document.querySelector(`input[name="party-filter"][value="${party}"]`);
      if (matchingRadio) matchingRadio.checked = true;
      updatePage('party', party);
      const target = document.querySelector('#politicians-list') || document.querySelector('.js-politician-table');
      if (target) {
        window.setTimeout(() => {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 50);
      }
    });
  });

  // Handle initial stock selection on page load
  const initialStock = new URLSearchParams(window.location.search).get('stock');
  if (initialStock) {
    const tradeSummaries = document.querySelector('.politician-trade-summaries');
    if (tradeSummaries) {
      tradeSummaries.style.display = 'none';
    }
  }

  if (window.location.pathname === '/congress-stock-trades') {
    syncCongressStockTradesTabs();
  }
}

function syncCongressStockTradesTabs() {
  if (window.location.pathname !== '/congress-stock-trades') return;
  const params = new URLSearchParams(window.location.search);
  const latestTradesActive = Boolean(params.get('stock')) || params.get('view') === 'latest_trades';
  const links = document.querySelectorAll('.secondary-tabs .secondary-tabs__link');
  if (links.length < 2) return;
  links[0].classList.toggle('secondary-tabs__link--active', !latestTradesActive);
  links[1].classList.toggle('secondary-tabs__link--active', latestTradesActive);
}

async function updatePage(param, newValue) {
  const url = new URL(window.location.href, window.location);
  if (newValue) {
    url.searchParams.set(param, newValue);
  } else {
    url.searchParams.delete(param);
  }
  if (url.pathname === '/congress-stock-trades' && url.searchParams.get('stock')) {
    url.searchParams.set('view', 'latest_trades');
  }

  // The monthly stock chart is server-rendered outside the table container.
  // Reload on stock changes so the chart shows/hides and updates correctly.
  if (param === 'stock') {
    window.location.href = url.toString();
    return;
  }

  window.history.pushState({}, '', url);

  // Hide/show trade summaries based on stock selection
  const tradeSummaries = document.querySelector('.politician-trade-summaries');
  if (tradeSummaries) {
    if (param === 'stock' && newValue) {
      tradeSummaries.style.display = 'none';
    } else if (param === 'stock' && !newValue) {
      tradeSummaries.style.display = 'block';
    }
  }

  url.searchParams.append('format', 'json');
  const response = await fetch(url);
  const json = await response.json();

  container.innerHTML = json.html;
  // used for infinite scrolling
  container.dataset.path = url;
  container.dataset.nextPage = 2;

  if (window.location.pathname === '/congress-stock-trades') {
    syncCongressStockTradesTabs();
  }
}

window.addEventListener('popstate', function () {
  if (window.location.pathname === '/congress-stock-trades/overview') {
    window.location.reload();
  }
});